

// Created successfully
export interface PostResponse {
  "data": any,
  "statusCode": number,
  "message": string,
  success: boolean,
}
